module.exports = __webpack_public_path__ + "static/media/no image-1.f66a73bc.svg";